import React, { useEffect, useState } from "react";
import UserService from "../../../services/UserService";
import { useSSEContext } from "../../../contexts/sse";
import Button from "../../../components/Button/Button";
import { UserAgentBrowserIcon, UserAgentOSIcon } from "../../../constants/user-agent";
import { formatDate } from "../../../utils/date";
import { useAuth } from "../../../contexts/auth";

export function UsersSessions(props) {
   const { sseReceived } = useSSEContext();
   const [sessions, setSessions] = useState([]);

   async function listUserSessions(userExternalId) {
      const response = await UserService.listUserSessions(userExternalId);
      setSessions(response ?? []);
   }

   useEffect(() => {
      listUserSessions(props.userExternalId);
   }, [props.userExternalId]);

   useEffect(() => {
      if (sseReceived?.action !== 'userConnectionToggle') return;
      const targetUser = sseReceived.content.targetUser;
      if (targetUser.userExternalId !== props.userExternalId) return;
      listUserSessions(props.userExternalId);
   }, [sseReceived]);

   function getUnitName(session) {
      if (!session.userData.selectedOrganizationId) {
         return 'Bravas Root';
      }
      if (session.userData?.selectedUnit?.name) return session.userData?.selectedUnit?.name;
      return '----';
   }

   return (
      <div className="grid grid-cols-3 gap-3">
         {sessions.map((session) => (
            <div key={session.id} className="p-3! rounded-lg border! border-(--borderColor)!">
               <div className="w-full flex justify-between border-b! border-(--borderColor)! pb-2.5! mb-2.5! text-lg">
                  <p>Em: {getUnitName(session)}</p>
                  <p>IP: {session.ip}</p>
               </div>
               <div className="w-full flex flex-col gap-2">
                  <div className="flex justify-between items-center">
                     <span className="opacity-60">Sistema Operacional:</span>
                     <span className="inline-flex gap-1">
                        {session.userAgent.os}
                        {React.createElement(UserAgentOSIcon[session.userAgent.os.toLowerCase()])}
                     </span>
                  </div>
                  <div className="flex justify-between items-center">
                     <span className="opacity-60">Navegador:</span>
                     <span className="inline-flex gap-1">
                        {session.userAgent.browser}
                        {React.createElement(UserAgentBrowserIcon[session.userAgent.browser.toLowerCase()])}
                     </span>
                  </div>
                  <div className="flex justify-between items-center">
                     <span className="opacity-60">Dispositivo:</span> {session.userAgent.device === 'Other' ? 'Desconhecido' : session.userAgent.device}
                  </div>
                  <div className="flex justify-between items-center">
                     <span className="opacity-60">Conectado em:</span> {formatDate(session.connectedAt, true)}
                  </div>
                  <div className="flex justify-between items-center">
                     <span className="opacity-60">Última atividade:</span> {session.lastActivity ? formatDate(session.lastActivity, true) : '----'}
                  </div>
               </div>
               <Button
                  className="button-red text-white mt-3!"
                  onClick={() => UserService.revokeUserSessions(session.userExternalId, session.id)}
                  label="Revogar"
               />
            </div>
         ))}
      </div>
   );
}